import { render } from "./LinkReset.vue?vue&type=template&id=2f29a749"
import script from "./LinkReset.vue?vue&type=script&lang=js"
export * from "./LinkReset.vue?vue&type=script&lang=js"

import exportComponent from "C:\\websites\\kroechkwis-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__